export const INVALID_PHONE_MSG =
  'Número invalido. Verifique se o número está correto.';

export const CHECK_RECEIVERS_DEFAULT_MESSAGE =
  'Confira abaixo o número em que será feito o envio do documento a ser assinado eletrônicamente pelo paciente.';
